import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]

  initialize() {
    this.save = this.save.bind(this)
  }

  connect() {
    this.timeout = null
  }

  saveDebounce(event) {
    // Only trigger auto-save if input value is changed or filled
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.save(event)
    }, 500)
  }

  save(event) {
    clearTimeout(this.timeout)
    const form = this.element
    
    // Find all number score inputs inside this form
    const inputs = form.querySelectorAll("input[type='number']")

    inputs.forEach(input => {
      if (input.value === "") {
        input.value = "0"
      }
    })

    const formData = new FormData(form)

    // Update status to saving
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = "Saving..."
      this.statusTarget.classList.remove("opacity-0")
      this.statusTarget.classList.remove("text-emerald-700", "bg-emerald-50", "border-emerald-200", "dark:text-emerald-300", "dark:bg-emerald-950/40", "dark:border-emerald-900/40")
      this.statusTarget.classList.remove("text-rose-700", "bg-rose-50", "border-rose-200", "dark:text-rose-300", "dark:bg-rose-950/40", "dark:border-rose-900/40")
      this.statusTarget.classList.add("text-amber-700", "bg-amber-50", "border-amber-200", "dark:text-amber-300", "dark:bg-amber-950/40", "dark:border-amber-900/40")
    }

    fetch(form.action, {
      method: "POST",
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
        "Accept": "text/vnd.turbo-stream.html, text/html, */*"
      }
    })
      .then(response => {
        if (response.ok) {
          if (this.hasStatusTarget) {
            this.statusTarget.textContent = "✓ Saved"
            this.statusTarget.classList.remove("text-amber-700", "bg-amber-50", "border-amber-200", "dark:text-amber-300", "dark:bg-amber-950/40", "dark:border-amber-900/40")
            this.statusTarget.classList.add("text-emerald-700", "bg-emerald-50", "border-emerald-200", "dark:text-emerald-300", "dark:bg-emerald-950/40", "dark:border-emerald-900/40")
            
            // Hide after 1.5 seconds
            setTimeout(() => {
              this.statusTarget.classList.add("opacity-0")
            }, 1500)
          }
        } else {
          if (this.hasStatusTarget) {
            this.statusTarget.textContent = "Error saving"
            this.statusTarget.classList.remove("text-amber-700", "bg-amber-50", "border-amber-200", "dark:text-amber-300", "dark:bg-amber-950/40", "dark:border-amber-900/40")
            this.statusTarget.classList.add("text-rose-700", "bg-rose-50", "border-rose-200", "dark:text-rose-300", "dark:bg-rose-950/40", "dark:border-rose-900/40")
          }
        }
      })
      .catch(error => {
        console.error("Auto-save error:", error)
        if (this.hasStatusTarget) {
          this.statusTarget.textContent = "Error"
          this.statusTarget.classList.remove("text-amber-700", "bg-amber-50", "border-amber-200", "dark:text-amber-300", "dark:bg-amber-950/40", "dark:border-amber-900/40")
          this.statusTarget.classList.add("text-rose-700", "bg-rose-50", "border-rose-200", "dark:text-rose-300", "dark:bg-rose-950/40", "dark:border-rose-900/40")
        }
      })
  }
}
